import "core-js/modules/es.string.link.js";
//
import { makeStyles, RaiseColors } from "client/componentLibrary";
import React from "react";
import { Link } from "react-router-dom";
import LogoFormatContainer from "./LogoFormatContainer";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    linkText: {
      textDecoration: "none",
      color: RaiseColors.white,
      paddingLeft: "4px",
      "&:hover": {
        color: RaiseColors.shamrock
      }
    },
    styledText: {
      color: RaiseColors.white,
      textAlign: "center"
    },
    noAccountText: {
      "float": "left",
      paddingRight: "3px",
      paddingLeft: "35px"
    },
    linkForm: {
      "float": "left"
    },
    link: {
      textDecoration: "none",
      color: RaiseColors.white,
      "&:hover": {
        color: RaiseColors.shamrock
      }
    }
  };
});
function WorkWithUs() {
  var classes = useStyles();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(LogoFormatContainer, {
      children: /*#__PURE__*/_jsxs("div", {
        className: classes.styledText,
        children: [/*#__PURE__*/_jsxs(_Fragment, {
          children: ["It looks like we haven\u2019t started working with you yet.", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), "If you want to work with us, please reach out at:"]
        }), /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("a", {
            href: "mailto:myportfolio@raise.work?Subject=Find Me Office Space!",
            target: "_top",
            className: classes.linkText,
            children: "myportfolio@raise.work"
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
        }), /*#__PURE__*/_jsx("div", {
          className: classes.noAccountText,
          children: "Not your account?"
        }), /*#__PURE__*/_jsx("div", {
          className: classes.linkForm,
          children: /*#__PURE__*/_jsx(Link, {
            to: "/raise_login/:next",
            className: classes.link,
            children: "Log into another account"
          })
        })]
      })
    })
  });
}
export default WorkWithUs;